export enum BrowserType {
  Opera = 'Opera',
  Edge = 'Edge',
  Chrome = 'Chrome',
  Safari = 'Safari',
  Firefox = 'Firefox',
  IE = 'Internet Explorer',
  Other = 'Other',
}
